/*
  Ciencia de datos            = 0
  IA                          = 1
  Tecnologías computacionales = 2
  Matemática                  = 3
  Ciencias complementarias    = 4

*/
export const career_data = {
    name: "Ingeniería en Tecnologías Computacionales para la Ciencia de Datos con grado de Bachillerato (BA-TECOMCD)",
    code: "BA-TECOMCD",
    mesh: {
        "0 0": {
            "#Ciencia de datos": [
                "Ciencia de datos",
                [],
                0
            ],
            "#Inteligencia Artificial": [
                "Inteligencia Artificial",
                [],
                1
            ],
            "#Tecnologías computacionales": [
                "Tecnologías computacionales",
                [],
                2
            ],
            "#Matemática": [
                "Matemática",
                [],
                3
            ],
            "#Ciencias complementarias": [
                "Ciencias complementarias",
                [],
                4
            ]
        },
        "1 1": {
            "GEN1": [
                "Estudios Generales I",
                [],
                4
            ],
            "GEN2": [
                "Estudios Generales II",
                [],
                4
            ],
            "TDC400": [
                "Lógica y Algoritmos Computacionales",
                [],
                2
            ],
            "MAT001": [
                "Matemática General",
                [],
                3
            ],
            "LIX410": [
                "Inglés Integrado I",
                [],
                4
            ]
        },
        "1 2": {
            "GEN3": [
                "Estudios Generales III",
                [],
                4
            ],
            "GEN4": [
                "Estudios Generales IV",
                [],
                4
            ],
            "MAT002": [
                "Cálculo I",
                ["MAT001"],
                3
            ],
            "LIX411": [
                "Inglés Integrado II",
                ["LIX410"],
                4
            ],
            "TDC401": [
                "Programación estructurada",
                ["TDC400"],
                2
            ]
        },
        "2 1": {
            "MAT005": [
                "Álgebra lineal",
                ["MAT002"],
                3
            ],
            "TDC402": [
                "Programación orientada a objetos",
                ["TDC401"],
                2
            ],
            "TDC403": [
                "Principios de investigación estadística",
                ["MAT001"],
                3
            ],
            "TDC404": [
                "Introducción a la Ciencia de Datos",
                ["TDC401"],
                0
            ],
            "TDC405": [
                "Algoritmos y estructura de Datos",
                ["TDC401"],
                2
            ]
        },
        "2 2": {
            "TDC406": [
                "Programación avanzada",
                ["TDC402"],
                2
            ],
            "TDC407": [
                "Fundamentos de Bases de Datos",
                ["TDC402"],
                0
            ],
            "TDC408": [
                "Inferencia Estadística para Ciencia de Datos I",
                ["TDC403", "MAT001"],
                3
            ],
            "TDC409": [
                "Ciencia de Datos Aplicada",
                ["TDC404"],
                0
            ],
            "TDC410": [
                "Fundamentos de Redes de Comunicación y Sistemas Distribuidos",
                ["TDC402"],
                2
            ]
        },
        "3 1": {
            "TDC411": [
                "Computación de Alto Rendimiento",
                ["TDC406", "TDC410"],
                2
            ],
            "TDC412": [
                "Base de datos Avanzadas",
                ["TDC407"],
                0
            ],
            "TDC413": [
                "Inteligencia Artificial y Aprendizaje máquina",
                ["MAT002", "TDC408"],
                1
            ],
            "TDC414": [
                "Visualización en Ciencia de datos",
                ["TDC409"],
                0
            ],
            "TDC415": [
                "Inferencia Estadística para Ciencia de Datos II",
                ["TDC408"],
                3
            ]
        },
        "3 2": {
            "TDC416": [
                "Programación masiva de datos",
                ["TDC412", "TDC414", "TDC406"],
                2
            ],
            "TDC417": [
                "Comunicación Efectiva",
                ["TDC404"],
                4
            ],
            "TDC418": [
                "Redes Neuronales artificiales y aprendizaje profundo",
                ["TDC413"],
                1
            ],
            "TDC419": [
                "Seguridad y Privacidad de los datos",
                ["TDC410", "TDC407"],
                0
            ],
            "TDC420": [
                "Computación en la Nube",
                ["TDC410", "TDC407"],
                2
            ]
        },
        "4 1": {
            "OPT1": [
                "Optativo 1",
                [],
                5
            ],
            "OPT2": [
                "Optativo 2",
                [],
                5
            ],
            "TDC421": [
                "Investigación aplicada a ciencia de datos",
                ["TDC415"],
                4
            ],
            "TDC422": [
                "Ingeniería de Software",
                ["TDC412", "TDC414"],
                2
            ],
            "TDC423": [
                "Gestión de Proyectos en Ciencia de Datos",
                ["TDC412", "TDC414"],
                0
            ]

        },
        "4 2": {
            "OPT3": [
                "Optativo 3",
                [],
                5
            ],
            "OPT4": [
                "Optativo 4",
                [],
                5
            ],

            "TDC426": [
                "Proyectos y su aplicación en la organización (PPS)",
                ["TDC416", "TDC417", "TDC418", "TDC419", "TDC420"],
                2
            ],
            "TDC424": [
                "Inteligencia de Negocios y Toma de Decisiones",
                ["TDC423"],
                0
            ],
            "TDC425": [
                "Ética y Gobernanza de la Información",
                ["TDC419"],
                2
            ]
        },
        "Opt": {
            "TDC100O": [
                "Industria 4.0 y sus aplicaciones",
                ["TDC411"],
                2
            ],
            "TDC101O": [
                "Inglés para otras carreras",
                [],
                4
            ],
            "TDC102O": [
                "Ciencia de Datos Aplicada al Internet de las Cosas",
                ["TDC404"],
                2
            ],
            "TDC103O": [
                "Ciencia de Datos para Medio Ambiente y Energía",
                ["TDC416", "TDC415"],
                4
            ],
            "TDC104O": [
                "Análisis de datos en redes sociales y marketing digital",
                ["TDC409", "TDC416"],
                4
            ],
            "TDC105O": [
                "Innovación y emprendimiento tecnológico",
                ["TDC413", "TDC408"],
                4
            ]
        }
    }
};